import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';
import {getServiceCategories} from '../../helpers/selectOptions';
import getServiceIcon from './getServiceIcon';

const PatientSchedulingServiceForm = ({
  onSubmit,
  stepNum = 2,
  allowedServiceCategories = null,
  subtitle = 'Select the type of care you need',
}) => {
  const options = getServiceCategories()
    .filter(cat => 
      !allowedServiceCategories
      || allowedServiceCategories.includes(cat.value)
    )
    .map(cat => ({
      label: cat.label,
      value: cat.value,
      description: cat.description,
      color: cat.colorName,
      xs: 12,
      md: 4,
      lg: 4,
      xl: 3,
    }));
  return (
    <Stack spacing={1} alignItems='center'>
      <Typography variant='h2'>Step {stepNum + 1}: What service are you looking for?</Typography>
      <Typography>{subtitle}</Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          useColoredBackground={false}
          options={options.map(o => ({...o, Icon: getServiceIcon({service: o.value})}))}
          onChange={(e, val) => onSubmit(e, val)}
        />
      </Box>
    </Stack>
  );
};

export default PatientSchedulingServiceForm;